exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  display: block;\n  text-align: center;\n  position: relative;\n  padding-top: 9vh;\n  font-size: 5vw;\n}\n\n.container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    text-align: center;\n  }\n\n.container > * {\n    width: 100%;\n  }\n\n/* form {\n    align-content: center;\n  } */\n\nbutton {\n    color: rgba(255,255,255,.87);\n    background-color: #232b2b;\n    margin-top: 20px;\n    z-index: 5;\n}\n\n@media screen and (max-width:1024px){\n\n  h1 {\n    font-size: 10vw;\n  }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main